import { lightTheme } from "@/customTheme"
import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M7.925 5.45H6.291V3.816c0-.464.386-.838.854-.817.446.02.78.424.78.87V5.45ZM2.998 7.086c0-.452.366-.818.817-.818h13.013a.9.9 0 0 1 .898.9v8.099h-1.634V7.904H3.815a.818.818 0 0 1-.817-.818Z"
      clipRule="evenodd"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M21.002 16.904a.818.818 0 0 1-.817.819H7.172a.9.9 0 0 1-.898-.9v-8.1h1.634v7.363h12.277c.451 0 .817.366.817.818ZM16.104 18.55h1.634v1.634a.817.817 0 0 1-.854.817c-.446-.02-.78-.424-.78-.87V18.55Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
